// NavigationMenu.tsx
import React, { useEffect, useState } from "react";
import { Alert } from "react-native";
import { HelpCircle, LogOut, MapPin, User } from "lucide-react-native";
import { secureStoreService } from "../shared/services/secure-store.service";
import { DecodedToken } from "../../types/token";
import { RestaurantMenu } from "../shared/types/restaurant.types";
import LoadingSpinnerTrans from "../shared/LoadingSpinner";
import GenericNavigationMenu from "../shared/component/GenericNavigationMenu";
import HeaderBack from "../shared/component/HeaderBack";
import { RootStackParamList } from "../../types/navigation";
import { StackScreenProps } from "@react-navigation/stack";
import { authService } from "../shared/services/auth.service";
import { asyncStorageService } from "../shared/services/async-store";

type Props = StackScreenProps<RootStackParamList, "Navigation">;

const NavigationMenu = ({ navigation }: Props) => {
  const [decToken, setDecToken] = useState<DecodedToken | null>(null);
  const [loading, setLoading] = useState(false);
  const [lText, setLText] = useState("Loading...");
  const [error, setError] = useState<Error | null>(null);
  const [restData, setRestData] = useState<RestaurantMenu>();

  useEffect(() => {
    const fetchToken = async () => {
      setLoading(true);
      try {
        const token: DecodedToken | null =
          await secureStoreService.getDecodedAccessToken();
        console.log("fetchToken token: ", token);

        setDecToken(token);
      } catch (error) {
        console.log("error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchToken();
  }, []);

  const handleLogOut = async () => {
    console.log("Logout clicked");

    // Show confirmation dialog
    Alert.alert("Confirm Logout", "Are you sure you want to logout?", [
      {
        text: "Cancel",
        style: "cancel",
      },
      {
        text: "Yes",
        onPress: async () => {
          try {
            setLoading(true);

            // Existing functionality
            await authService.logout(); //clears local cache as well
            //TODO: clear local file dir for containing cdn images etc.
            await asyncStorageService.clearCdnCache();
            navigation.replace("Login", {});
            Alert.alert("Success", "Logout Successful");
          } catch (error) {
            console.error("Logout error:", error);
            Alert.alert("Error", "Failed to logout. Please try again.");
          } finally {
            setLoading(false);
          }
        },
      },
    ]);
  };

  const menuSections = [
    {
      items: [
        {
          icon: User,
          title: "My Account",
          onPress: () => {
            console.log("My Account called");
            navigation.navigate("UserAccountScreen");
          },
        },
        {
          icon: MapPin,
          title: "Addresses",
          onPress: async () => {
            navigation.navigate("UserAddress");
          },
        },
        {
          icon: HelpCircle,
          title: "Support",
          onPress: () => navigation.navigate("Help"),
        },
        {
          icon: LogOut,
          title: "Logout",
          onPress: handleLogOut,
          isDestructive: true,
        },
      ],
    },
  ];

  return (
    <>
      <GenericNavigationMenu
        CustomHeader={<HeaderBack title="Settings" />}
        profileName={"User Name Here"} //TODO
        profileSubtext={decToken?.email}
        menuSections={menuSections}
      />
      {loading && <LoadingSpinnerTrans text={lText} />}
    </>
  );
};

export default NavigationMenu;
